import { Action } from '@ngrx/store';

export enum ActionTypes {
  FETCH_CONTRACTS = '[Location Specification] Fetch Contracts',
  ADD_CONTRACTS = '[Location Specification] Add Contracts',
  CLEAR_CONTRACTS = '[Location Specification] Clear Contracts',
  NO_ACTION = '[Location Specification] No Action',
}

export class FetchContracts implements Action {
  readonly type = ActionTypes.FETCH_CONTRACTS;
  constructor(
    public payload: { orderFormId: number; productId: number; jobsiteId: number; shippingConditionId: number },
  ) {}
}

export class AddContracts implements Action {
  readonly type = ActionTypes.ADD_CONTRACTS;
  constructor(public payload: { orderFormId: number; contracts: any[] }) {}
}

export class ClearContracts implements Action {
  readonly type = ActionTypes.CLEAR_CONTRACTS;
  constructor() {}
}

export class NoAction implements Action {
  readonly type = ActionTypes.NO_ACTION;
  constructor() {}
}

export type Actions = FetchContracts | AddContracts | ClearContracts | NoAction;
